import { render } from "./costing_detail.vue?vue&type=template&id=03f49abf"
import script from "./costing_detail.vue?vue&type=script&lang=js"
export * from "./costing_detail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__